module.exports = {
  UPGRADE_LINK: {
    FOR_PERSONAL: '/myaccount/bundle/business/upgrade',
    FOR_DEVELOPER:
      '/signin/client?intent=developer&flow=upgradeUser&type=business&returnUrl=https://www.paypal.com&returnUrl=https%3A%2F%2Fwww.paypal.com%2Fus%2Fmerchantsignup%2Frouter%3FreturnUrl%3Dhttps%3A%2F%2Fdeveloper.paypal.com%2Fdeveloper%2Fapplications',
  },
  ACCOUNT_TYPE: {
    PERSONAL: 'PERSONAL',
    BUSINESS: 'BUSINESS',
    PREMIER: 'PREMIER',
    IDENTITY: 'IDENTITY',
  },
  HOST_NAME: {
    LIVE: 'https://www.paypal.com',
    MSM: 'https://www.msmaster.qa.paypal.com',
  },
  ENVIRONMENT: {
    DEVELOPMENT: 'development',
    STAGE: 'stage',
    PRODUCTION: 'production',
    LIVE: 'LIVE',
  },
  FPTI_PAGES_CATEGORIES: {
    ERROR_LOGS: 'Error logs',
    ERROR_LOGS_DETAIL_MODAL: 'Error logs Detail Modal',
    API_CALLS_DETAIL_MODAL: 'API Calls Detail Modal',
    HOME_PAGE_ERROR_LOGS_DETAIL_MODAL: 'Home page Error logs Detail Modal',
    WEBHOOKS_EVENTS_DETAIL_MODAL: 'Webhooks events Detail Modal',
    HOME_PAGE_MONITORING: 'Home page monitoring',
    HOME_PAGE_ERROR_SUMMARY: 'Home page error summary',
    HOME_PAGE_ERROR_LOG: 'Home page error log',
    HOME_PAGE_TRANSACTION_FAILED_SUMMARY:
      'Home page recent transaction failure summary',
    HOME_PAGE_RECENT_TRANSACTION: 'Home page recent transaction',
    TOP_NAV: 'Top nav',
  },
  FPTI_COMPONENTS_CATEGORIES: {
    CODE_BLOCK: 'code-block',
    ALERT_ERROR: 'alert-error',
    CREATE_APP: 'create-app',
  },
  FPTI: {
    WEBHOOK_DETAIL_MODAL: 'Webhooks Event Detail Modal',
    APP_DETAILS: {
      BACK_BUTTON: 'App details back button',
      CLIENT_ID_COPY_CLIPBOARD: 'Copy credentials to clipboard',
      SECRET_ID_COPY_CLIPBOARD: 'Copy secret id to clipboard ',
      SECRET_ID_MENU_ENABLE: 'Select secret id menu enabled',
      SECRET_ID_MENU_DISABLE: 'Select secret id menu disabled',
      SECERT_ID_MENU_DELETE: 'Select secret id menu delete option',
      SECRET_ID_HIDE: 'Secret id is toggle between hide and show',
      ADD_SECRET_KEY: 'Add second secret key',
      DELETE_SECRET_KEY: 'Delete second secret key',
      CANCEL_DELETE_SECRET_KEY: 'Cancel delete second secret key',
      ADD_WEBHOOK: 'App details Add webhook button',
      SECRET_ID_MENU_OPEN:
        'Secret id click in the menu for enable/disabled and delete',
      VIEW_LIVE_ALERT: 'App details view live credentials alert',
    },
    APPS_CREDS: {
      SANDBOX_ACCT_INFO: 'Apps & Creds sandbox account info',
      LIVE_ACCT_INFO: 'Apps & Creds live account info',
      VIEW_LIVE_ALERT: 'Apps & Creds view live credentials alert',
    },
  },
  ELMO: {
    CTRL_DEVELOPER_SERVER_MIGRATION: 'Ctrl_Developer_Server_Migration',
    TRMT_DEVELOPER_FEATURE_FLAG: 'Trmt_developer_feature_flag',
  },
  APP_ENV: {
    LIVE: 'live',
    SANDBOX: 'sandbox',
  },
}
